<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-medium-size-100">
      <md-card>
        <!--        <md-card-header>-->
        <!--          <h4 class="title">Collapsible Accordion</h4>-->
        <!--        </md-card-header>-->
        <md-card-content>
          <collapse
              :collapse="collapse"
              icon="keyboard_arrow_down"
              color-collapse="success"
          >
            <template v-for="(item, index) in collapse" :slot="`md-collapse-pane-${index+1}`">
              <p v-for="(doc)  in list[index].docs" :key="item.name + doc.title">
                <a :href="doc.link" target="_blank">{{ doc.title }}</a>
              </p>

            </template>
          </collapse>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import {Collapse} from "@/components"

export default {
  name: "Manuals",
  components: {
    Collapse
  },
  data() {
    return {
      list: [
        {
          name: "BEMSS",
          docs: [{
            title: "Bridge Inspection Manual",
            link: "/manuals/Bridge Inspection Manual-April.pdf"
          },
            {
              title: "BEMSS User Manual",
              link: "/manuals/BMS_User_Manual_2023.pdf"
            }]
        }
      ]
    }
  },
  computed: {
    collapse() {
      return this.list.map(item => item.name)
    }
  }
}
</script>

<style scoped>

</style>
